import { render, staticRenderFns } from "./ManagerRoom.vue?vue&type=template&id=1bd222ca&scoped=true&"
import script from "./ManagerRoom.vue?vue&type=script&lang=js&"
export * from "./ManagerRoom.vue?vue&type=script&lang=js&"
import style0 from "./ManagerRoom.vue?vue&type=style&index=0&id=1bd222ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd222ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDialog,VRow})
